import { GraphicObject } from "../graphic-object";

export class WebglObjectGroup extends GraphicObject {
  constructor(settings) {
    super(settings);
    this.itemsContainer = this.settings.itemsContainer;
  }

  setDebugMode(debugSettings) {
    this.settings.isDebugMode = true;
    this.settings.debug = debugSettings;
    this.itemsContainer.forEach(item => item.setDebugMode(debugSettings));
  }

  draw(gl, program) {
    this.itemsContainer.recursiveExecute("draw", gl, program);
  }

  createBorders() {
    super.createBorders();
    this.itemsContainer.forEach(item => {
      item.setParentSize(this.settings.sizeInPixels.width, this.settings.sizeInPixels.height);
      item.createBorders();
    });
  }
}
